/**
 * Where the outputs come from: the ones already saved in the dataset version
 * (no file needed), or a JSON / CSV file keyed by item. The dataset's own
 * outputs are the default when the version has any.
 */

import { Field, Option } from "@/components/ui/field";
import { FileDrop } from "@/components/ui/file-drop";

export type OutputSource = "dataset" | "file";

export function RecordedSource({
  source,
  hasDatasetOutputs,
  onSource,
  file,
  fileError,
  onFile,
}: {
  source: OutputSource;
  hasDatasetOutputs: boolean;
  onSource: (s: OutputSource) => void;
  file: string | undefined;
  fileError: string | null;
  onFile: (f: File | undefined) => void;
}) {
  return (
    <>
      {hasDatasetOutputs && (
        <fieldset className="flex flex-col gap-2">
          <legend className="pb-2 text-[13px] font-semibold">Outputs to score</legend>
          <Option
            type="radio"
            name="rec-source"
            checked={source === "dataset"}
            onChange={() => onSource("dataset")}
          >
            Use the outputs in this dataset
          </Option>
          <Option
            type="radio"
            name="rec-source"
            checked={source === "file"}
            onChange={() => onSource("file")}
          >
            Upload a file instead
          </Option>
        </fieldset>
      )}
      {source === "file" && (
        <Field
          label="Outputs file"
          required
          htmlFor="rec-file"
          error={fileError}
          hint="JSON list or CSV. Each record has item_key (or item_id) and output; repetition, trace_id, cost_usd, latency_ms and error are optional."
        >
          <FileDrop
            id="rec-file"
            accept=".json,.csv,application/json,text/csv"
            label="Outputs file"
            title={
              <>
                Drop a JSON or CSV file here, or <span className="text-link">choose one</span>
              </>
            }
            fileName={file}
            onFile={onFile}
          />
        </Field>
      )}
    </>
  );
}
